import { AppTrackingTransparency } from 'capacitor-plugin-app-tracking-transparency';

import { logToDatadog } from '@/domains/shared/analytics/datadogUtils';
import { isIOS, isNative } from '@/domains/shared/utils/native';

/**
 * Requests App Tracking Transparency permission on iOS native only.
 * No-ops on web and Android so callers can always await this before
 * starting tracking SDKs.
 */
export async function requestIosAttPermission(): Promise<void> {
  const isIosNative = isNative() && isIOS();
  if (!isIosNative) return;

  try {
    const { status } = await AppTrackingTransparency.getStatus();
    const finalStatus =
      status === 'notDetermined'
        ? (await AppTrackingTransparency.requestPermission()).status
        : status;

    logToDatadog('info', 'ATT permission resolved', { status: finalStatus });
  } catch (error) {
    logToDatadog('error', 'ATT permission request failed', {
      error: error instanceof Error ? error.message : String(error),
    });
  }
}
